































import Vue from 'vue'
import { State } from 'vuex-class'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { User } from '@/modules/User/interfaces/user'

@Component({
  components: {}
})
export default class MenuChecklist extends Vue {
  @Prop({ type: Number }) readonly left!: number;
  @Prop({ type: Number }) readonly top!: number;
  @Prop({ type: String }) readonly text!: string;

  @State((state) => state.user.me) me!: User;

  async mounted () {}

  show = false;

  onHide () {
    this.show = false
  }

  onClick () {
    this.show = !this.show
  }

  @Emit('search')
  handleSearch () {}
}
